import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ICalendarFilter } from '../models/calendar-filter';
import { ICalendarFilterOptions } from '../models/calendar-filter-options';

export const calendarApi = createApi({
  reducerPath: 'calendar',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/calendar'
  }),
  endpoints: build => ({
    getCategories: build.query<ICalendarFilterOptions, void>({
        query: () => ({
            url: 'getFiltersOptions',
            method: 'POST'
      })
    }),
      getEvents: build.mutation<Array<Object>, { [key: string]: any }>({
          query: (filter: ICalendarFilter) => ({
        url: `getEvents`,
            method: 'POST',
            body: filter
      })
    })
  })
});
